/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Warunki wynajmu') {
            document.title = 'Warunki wynajmu';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>WARUNKI WYNAJMU</b></Typography><br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Strona internetowa  przeznaczona jest do rezerwacji noclegów w pokojach.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Właścicielem serwisu oraz prezentowanych na stronie pokoi jest firma <b>MARLAND P. MARCZYDŁO DEWELOPER SP. K</b> K 36-062 Zaczernie 917 NIP: 5170378444 FORREST, Rzeszowska 56, 36-060 Głogów  Małopolski,  <a href="https://www.forrestroom.pl/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            www.forrestroom.pl
                        </Button>,
                    </a> tel.<a href={`tel:${'+48531898551'}`} className={`${classes.email}`}>{'+48 531 898 551'}</a>, adres poczty elektronicznej: <a href={`mailto:${'recepcja@forrestroom.pl'}`} target='_blank' className={`${classes.email}`}>{'recepcja@forrestroom.pl'}</a> </Typography></li>
                    <li><Typography variant='body2' gutterBottom>Numer rachunku bankowego 95 9159 0000 2001 0012 4298 0001</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacji pokoi można dokonywać drogą telefoniczną, pocztą elektroniczną lub  on-line za pośrednictwem serwisu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Warunkiem rezerwacji jest płatność on-line 100% ceny za wynajem w momencie rezerwacji.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Możliwa jest płatność za rezerwację on-line jak również w obiekcie przy zameldowaniu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności jest <b>mBank.</b></Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacji można również dokonywać przez portal rezerwacyjny <a href="https://www.booking.com/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            booking.com
                        </Button>
                    </a>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności w przypadku rezerwacji przez serwis rezerwacyjny <a href="https://www.booking.com/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            booking.com
                        </Button>
                    </a> jest ten serwis.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W obiekcie akceptujemy karty płatnicze, płatność przelewem, gotówkę i blik.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zakwaterowanie w pokojach odbywa się w hotelu na podstawie rezerwacji telefonicznej, drogą pocztową, na miejscu lub przez portal booking.com i jest wymagany dokument tożsamości. Płatność jest wymagana przy zameldowaniu gościa. Zakwaterowanie jest możliwe od godziny 14:00, wymeldowanie do godz. 11:00 ostatniego dnia pobytu. Nasz obiekt jest otwarty całodobowo i zawsze jest recepcjonista do dyspozycji gości.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W przypadku anulowania rezerwacji na jeden lub więcej dni przed przyjazdem, Gość otrzyma pełny zwrot wpłaconych środków. Zwrot będzie wykonany w ciągu maksymalnie 7 dni roboczych na wskazany rachunek bankowy. W przypadku anulowania na mniej niż 1 dni przed przyjazdem, klient jest zobowiązany uregulować należność w wysokości ceny za pierwsza noc hotelową.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wszelkie reklamacje powinny być zgłaszane pisemnie poprzez formularz kontaktowy na stronie <a href="https://www.forrestroom.pl/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            www.forrestroom.pl
                        </Button>
                    </a> lub mailowo na adres <a href={`mailto:${'recepcja@forrestroom.pl'}`} target='_blank' className={`${classes.email}`}>{'recepcja@forrestroom.pl'}</a>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Czas odpowiedzi na reklamację wynosi do 7 dni roboczych.</Typography></li>
                </ol>
                
            
                {/* <br /><Typography align="right" gutterBottom>Dyrektor PPUH Hayduk</Typography>
                <Typography align="right" gutterBottom><b>Koralewska Monika</b></Typography> */}
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    noMarginTop: {
        marginTop: 0,
    },
    noMarginBottom: {
        marginBottom: 0,
    },
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
